import c from "./lib/createApi";

export default {
  get: c("GET", "/v1/assistant", true),
  put: c("PUT", "/v1/assistant", true),
  submit: c("POST", "/v1/assistant", true), // 감사, 위원 등록
  newSubmit: c("POST", "/v1/assistant/newsubmit", true), // 회원가입이후 감사, 위원 동시 등록
  gets: c("POST", "/v1/committee?fieldId=:id", true), // 감사, 위원 등록
};
